import { z } from 'zod'

import {
	REGULATORY_FEED_FREQUENCY_OPTIONS,
	REGULATORY_FEED_OPTIONS,
} from '#app/routes/mocra+/_form+/intake-options.ts'

export const MonitoringFeedEntrySchema = z.object({
	source: z.enum(
		REGULATORY_FEED_OPTIONS.map((option) => option.value) as [
			(typeof REGULATORY_FEED_OPTIONS)[number]['value'],
			...string[],
		],
	),
	frequency: z.enum(
		REGULATORY_FEED_FREQUENCY_OPTIONS.map((option) => option.value) as [
			(typeof REGULATORY_FEED_FREQUENCY_OPTIONS)[number]['value'],
			...string[],
		],
	),
	detail: z
		.string({
			required_error: 'Describe what the feed covers.',
		})
		.min(1, 'Describe what the feed covers.')
		.max(160, 'Keep the description under 160 characters.'),
})

export type MonitoringFeedEntry = z.infer<typeof MonitoringFeedEntrySchema>
